Customer.Ticket ||= {}

class Customer.Ticket.TicketHeaderView extends Backbone.View
  template: JST["backbone/templates/customer/ticket/header/header"]
  emptyTemplate: JST["backbone/templates/customer/ticket/header/empty_header"]
  id: 'ticket-header'

  initialize: (@options = {}) ->
    @model = @options.model
    @assignmentView = @_initializeAssignmentView() if @model
    @authorView = new Customer.Ticket.AuthorView(model: @model)

  render: ->
    if @model
      @$el.html(@template(model: @model, self: @))
      @$el.find('#assignment').html(@assignmentView.render().el).css(display: 'inline-block')
    else
      @$el.html(@emptyTemplate())
    @$el.find('.author').html(@authorView.render().el)
    @

  changePriority:(priority)->
    @showPrioritySpinner()
    @model.changePriority({priority: parseInt(priority)})

  getTranslationFor: (status) ->
    I18n.t('customer.dashboard.conversations.status.' + status.toLowerCase().replace(' ', '_'))

  _initializeAssignmentView: ->
    if ((!@model.get('can_update')) && @model.get('status') == 'Closed' && @model.get('can_self_assign_closed_tickets'))
      new Customer.Dashboard.SelfAssignmentView(@options.data.users_groups, @model, @options.data.users, Keepcon.current_user)
    else
      new Customer.Dashboard.AssignmentView(@options.data.users_groups, @model, @options.data.users, Keepcon.current_user)

  showPrioritySpinner: ->
    @$el.find('#loading-priority').show()

  hidePrioritySpinner: ->
    @$el.find('#loading-priority').hide()
